import React, { useEffect, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid } from 'recharts';
import api from '../../utils/api';

export default function EnrollmentReportPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/v1/reports/enrollment-summary')
      .then(r => setData((r.data || []).map(row => ({
        name: `P${row.project_id}/C${row.class_id}`,
        Sindhi: Number(row.sindhi_total) || 0,
        Urdu: Number(row.urdu_total) || 0,
        English: Number(row.english_total) || 0,
        Mixed: Number(row.mixed_total) || 0,
        Total: Number(row.grand_total) || 0,
      }))))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const totals = data.reduce((acc, r) => ({
    sindhi: acc.sindhi + r.Sindhi, urdu: acc.urdu + r.Urdu,
    english: acc.english + r.English, total: acc.total + r.Total
  }), { sindhi: 0, urdu: 0, english: 0, total: 0 });

  const nf = n => n.toLocaleString();

  if (loading) return <p style={{ padding: 24 }}>Loading…</p>;

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ marginBottom: 8 }}>Enrollment Report</h2>
      <p style={{ color: '#666', marginBottom: 20 }}>Medium-wise breakdown by project and class</p>

      <div style={{ display: 'flex', gap: 16, marginBottom: 24, flexWrap: 'wrap' }}>
        {[['Total Students', totals.total, '#059669'], ['Sindhi Medium', totals.sindhi, '#6366f1'],
          ['Urdu Medium', totals.urdu, '#f59e0b'], ['English Medium', totals.english, '#0ea5e9']].map(([label, val, color]) => (
          <div key={label} style={{ flex: '1 1 160px', background: '#fff', borderRadius: 10, padding: '16px 20px', boxShadow: '0 1px 4px rgba(0,0,0,.08)', borderTop: `3px solid ${color}` }}>
            <div style={{ fontSize: 22, fontWeight: 700, color }}>{nf(val)}</div>
            <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>{label}</div>
          </div>
        ))}
      </div>

      {data.length === 0 ? (
        <p style={{ color: '#888' }}>No enrollment data available.</p>
      ) : (
        <div style={{ background: '#fff', borderRadius: 12, padding: 24, boxShadow: '0 1px 4px rgba(0,0,0,.08)' }}>
          <h4 style={{ marginBottom: 16 }}>Students by Project / Class</h4>
          <ResponsiveContainer width="100%" height={320}>
            <BarChart data={data} margin={{ top: 4, right: 20, bottom: 4, left: 10 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis dataKey="name" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip />
              <Legend />
              <Bar dataKey="Sindhi"  fill="#6366f1" radius={[4,4,0,0]} />
              <Bar dataKey="Urdu"    fill="#f59e0b" radius={[4,4,0,0]} />
              <Bar dataKey="English" fill="#0ea5e9" radius={[4,4,0,0]} />
              <Bar dataKey="Mixed"   fill="#8b5cf6" radius={[4,4,0,0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}

      {data.length > 0 && (
        <div style={{ background: '#fff', borderRadius: 12, padding: 24, boxShadow: '0 1px 4px rgba(0,0,0,.08)', marginTop: 20 }}>
          <h4 style={{ marginBottom: 12 }}>Detailed Breakdown</h4>
          <table className="table" style={{ fontSize: 13 }}>
            <thead><tr><th>Project</th><th>Class</th><th>Sindhi</th><th>Urdu</th><th>English</th><th>Mixed</th><th>Total</th></tr></thead>
            <tbody>
              {data.map((r, i) => (
                <tr key={i}>
                  <td>P{r.name.split('/')[0].replace('P','')}</td>
                  <td>C{r.name.split('/')[1].replace('C','')}</td>
                  <td>{nf(r.Sindhi)}</td><td>{nf(r.Urdu)}</td>
                  <td>{nf(r.English)}</td><td>{nf(r.Mixed)}</td>
                  <td><strong>{nf(r.Total)}</strong></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
